import React from 'react';

import ChartBar from './ChartBar';
import './Chart.css';

const Chart = (props) => {

  const dataPointValues = props.dataPoints.map(dataPoint => dataPoint.value); // mapping 
  // all data point values.
  const totalMaximum = Math.max(...dataPointValues); // setting the maximum bar fill up
  // from all the values maximum value.

  // Here creating the chartBar, from datapoints, for each datapoint, create a ChartBar,
  // with key as the month index, value as it's datapoint value of the month, maxValue
  // as the max capacity of the bar, and label as month index as well.
  return (
    <div className='chart'>
      {props.dataPoints.map((dataPoint) => (
        <ChartBar
          key={dataPoint.label}
          value={dataPoint.value}
          maxValue={totalMaximum}
          label={dataPoint.label}
        />
      ))}
    </div>
  );
};

export default Chart;